var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_vm._v("\n\n\n\n    Server offline for scheduled maintenance. TaskTeacher be back online soon.\n\n\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }